import React from 'react';
import { useReplay } from '../context/ReplayContext';
import './ReplayBanner.css';

function ReplayBanner() {
  const { isReplayMode, replaySession, exitReplay } = useReplay();

  if (!isReplayMode || !replaySession) {
    return null;
  }

  const handleExit = async () => {
    await exitReplay();
    // Reload to refresh data from the actual database
    window.location.href = '/dashboard';
  };

  // Truncate long titles
  const displayTitle = replaySession.deck_title?.length > 40
    ? replaySession.deck_title.substring(0, 37) + '...'
    : replaySession.deck_title;

  return (
    <div className="replay-banner">
      <div className="replay-banner-header">
        <span className="replay-badge">REPLAY</span>
      </div>
      <div className="replay-deck-title">
        {displayTitle}
      </div>
      <button className="replay-exit-btn" onClick={handleExit}>
        Exit
      </button>
    </div>
  );
}

export default ReplayBanner;
